import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import React from 'react';
import TextBlock from 'libs/wordpress/content/cmsBlocks/TextBlock';
import moduleMargins from 'config/theme/moduleMargins';

const TextLayout = ({ ...rest }) => (
    <MaxWidthWrapper includeContentMargins as="section" my={moduleMargins.md}>
        <TextBlock {...rest} />
    </MaxWidthWrapper>
);

export default TextLayout;
